<template>
  <div>
    <br>
    <h4>Questions</h4>
    <br>
    <div v-if="!loading && questionlist.length < 2">
      Please select a survey first
    </div>
    <div v-else>
      <div class="row font-weight-bold" >
        <div class="col-3">
          Question
        </div>
        <div class="col-4">
          Options
        </div>
        <div class="col-2 required small font-weight-bold">
          Measure or Topic/Element Name
        </div>
        <div class="col-1 small font-weight-bold">
          Is Topic/Element
        </div>
        <div class="col-1 small font-weight-bold">
          Score Inverse
        </div>
        <div class="col-1 small font-weight-bold">
          Has Comments
        </div>
      </div>
      <div v-if="loading">
        <font-awesome-icon icon="spinner" size="3x" spin/>
      </div>
      <div v-else>
        <question-item v-for="question in questionlist" :key="question.id" :question="question" v-if="questionlist.length > 1" v-on:update:question="updateQuestion($event)"></question-item>
      </div>
    </div>
    <!-- debug: {{ questionlist.length }} -->
  </div>
</template>
<script>
import QuestionItem from '@/components/QuestionItem.vue'
import * as API from "@/services/API"

export default {
  name: 'QuestionTable',  
  components: {
    QuestionItem
  },
  props: {
    questions: {
      default: function() { return [] },
      type: Array
    },
    survey: {
      default: null,
      type: Object
    },
    date: {
      default: null,
      type: Date
    },
    template: null
  },
  watch: { 
    // dirty - monitor the value for changes
    survey: function(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.selected_survey = newVal
        this.fetchData()
      }
    },
    template: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.useTemplate();
      }
    }
  },
  data() {
    return {
      questionlist: (this.questions ? new Array(this.questions) : []),
      selected_survey: this.survey || null,
      loading: false
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      if(!this.selected_survey) {
        return
      }

      this.loading = true
      return API.getSurvey(this.selected_survey.id,this.$root.token).then(res => {
        // now use
        this.questionlist = res.questions
        this.dateCreated = res.dateCreated
        this.useTemplate();
        this.loading = false
        this.selectionMade()
      })
    },
    selectionMade (e) {
      this.$emit('update:questions', { 
        questions: this.questionlist,
        date: this.dateCreated
      })
    },
    useTemplate() {
      if (!this.questionlist) return;
      // pre-fill dimensions and questions
      // get from templates
      var dimensionTemplates = [];
      var questionTemplates = [];
      const scoreBackwardsTemplates = [];
      this.template.forEach(function(questionOrDimension) {
        if (questionOrDimension.dimension) {
          dimensionTemplates.push(questionOrDimension.local_name);
        } else {
          questionTemplates.push(questionOrDimension.local_name);
          scoreBackwardsTemplates.push(questionOrDimension.score_backwards);
        }
      });
      
      // assign to our questions
      let dimensionCounter = 0;
      let questionCounter = 0;
      var that = this;
      this.questionlist.forEach(function(question, index) {
        if (question.dimension && dimensionCounter < dimensionTemplates.length) {
          that.questionlist[index].local_name = dimensionTemplates[dimensionCounter];
          dimensionCounter += 1;
        } else if (questionCounter < questionTemplates.length) {
          that.questionlist[index].local_name = questionTemplates[questionCounter];
          that.questionlist[index].score_backwards = scoreBackwardsTemplates[questionCounter];
          questionCounter += 1;
        }
      });
    },
    updateQuestion (e) {
      if(e.survey_monkey_question_id) {
        // loop over the questions and update the correct one
        for(let i = 0; i < this.questionlist.length; i++) {
          let q = this.questionlist[i]
          if(q.survey_monkey_question_id === e.survey_monkey_question_id) {
            // special Vue voodoo to replace an array item
            this.$set(this.questionlist, i, e)
            this.selectionMade()
            break
          }
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/QuestionTable.vue